import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, Transition as _Transition, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_2 = {
  class: "lg:col-span-3"
};
const _hoisted_3 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_5 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_6 = {
  class: "data-table-shell"
};
const _hoisted_7 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_8 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "flex items-start gap-2.5 max-w-[260px]"
};
const _hoisted_12 = {
  class: "min-w-0 flex-1"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = {
  class: "data-table-cell-meta mt-1 flex items-center gap-2"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  key: 0,
  class: "flex flex-wrap gap-1 max-w-[150px]"
};
const _hoisted_18 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_19 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_20 = {
  class: "data-table-td text-center"
};
const _hoisted_21 = {
  class: "data-table-td text-center"
};
const _hoisted_22 = {
  key: 0,
  class: "text-amber-500"
};
const _hoisted_23 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_24 = {
  class: "data-table-td text-center text-slate-600"
};
const _hoisted_25 = {
  class: "data-table-td text-center"
};
const _hoisted_26 = {
  class: "flex items-center justify-center gap-2 text-xs"
};
const _hoisted_27 = {
  class: "text-emerald-600"
};
const _hoisted_28 = {
  class: "text-red-500"
};
const _hoisted_29 = {
  class: "data-table-td text-center"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_32 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  class: "relative more-menu-container"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_39 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_40 = {
  class: "text-lg font-semibold text-white"
};
const _hoisted_41 = {
  class: "mt-0.5 text-sm text-primary-100"
};
const _hoisted_42 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_43 = {
  class: "space-y-1.5"
};
const _hoisted_44 = {
  class: "space-y-1.5"
};
const _hoisted_45 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_46 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_47 = {
  class: "space-y-1.5"
};
const _hoisted_48 = {
  class: "space-y-1.5"
};
const _hoisted_49 = {
  class: "space-y-1.5"
};
const _hoisted_50 = {
  class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
const _hoisted_51 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_52 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_53 = {
  class: "text-lg font-semibold text-white"
};
const _hoisted_54 = {
  class: "mt-0.5 text-sm text-primary-100"
};
const _hoisted_55 = {
  class: "overflow-y-auto max-h-[calc(90vh-180px)] px-6 py-6 space-y-5"
};
const _hoisted_56 = {
  class: "space-y-4"
};
const _hoisted_57 = {
  class: "space-y-4 rounded-xl border border-slate-200 bg-slate-50/30 p-4"
};
const _hoisted_58 = {
  class: "space-y-1.5"
};
const _hoisted_59 = {
  class: "space-y-1.5"
};
const _hoisted_60 = {
  class: "space-y-4"
};
const _hoisted_61 = {
  class: "space-y-4"
};
const _hoisted_62 = {
  class: "space-y-4 rounded-xl border border-slate-200 bg-slate-50/30 p-4"
};
const _hoisted_63 = {
  class: "space-y-1.5"
};
const _hoisted_64 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_65 = {
  class: "space-y-1.5"
};
const _hoisted_66 = {
  class: "space-y-1.5"
};
const _hoisted_67 = {
  class: "space-y-1.5"
};
const _hoisted_68 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_69 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_70 = {
  class: "overflow-y-auto max-h-[calc(90vh-100px)] px-6 py-6"
};
const _hoisted_71 = {
  key: 0,
  class: "space-y-4 animate-pulse"
};
const _hoisted_72 = {
  class: "flex flex-wrap items-center gap-3"
};
const _hoisted_73 = {
  key: 0,
  class: "flex items-center gap-1 rounded-full status-badge is-warning px-2.5 py-1 text-xs font-medium"
};
const _hoisted_74 = {
  class: "flex items-center gap-1.5 rounded-full status-badge is-neutral px-2.5 py-1 text-xs font-medium"
};
const _hoisted_75 = {
  class: "mt-4 text-xl font-bold text-slate-900"
};
const _hoisted_76 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-1.5"
};
const _hoisted_77 = {
  class: "mt-4 flex items-center gap-4 text-xs text-slate-500"
};
const _hoisted_78 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_79 = {
  class: "flex items-center gap-1.5 text-emerald-600"
};
const _hoisted_80 = {
  class: "flex items-center gap-1.5 text-red-500"
};
const _hoisted_81 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_82 = {
  class: "mt-6"
};
const _hoisted_83 = {
  class: "rounded-xl border border-slate-200 bg-slate-50/50 p-5"
};
const _hoisted_84 = {
  class: "prose prose-sm max-w-none text-slate-700"
};
const _hoisted_85 = {
  class: "mt-6 flex flex-wrap items-center gap-4 rounded-xl border border-slate-100 bg-slate-50/50 px-4 py-3 text-xs text-slate-500"
};
const _hoisted_86 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_87 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_88 = {
  key: 0,
  class: "fixed inset-0 z-50",
  role: "dialog",
  "aria-modal": "true"
};
const _hoisted_89 = {
  class: "absolute right-0 top-0 h-full w-full max-w-lg overflow-hidden bg-white shadow-2xl ring-1 ring-black/5"
};
const _hoisted_90 = {
  class: "flex h-full flex-col"
};
const _hoisted_91 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_92 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_93 = {
  class: "min-w-0 flex-1 mr-4"
};
const _hoisted_94 = {
  class: "mt-1 text-sm text-primary-100 truncate"
};
const _hoisted_95 = {
  class: "flex-1 overflow-y-auto px-6 py-5"
};
const _hoisted_96 = {
  key: 0,
  class: "space-y-4 animate-pulse"
};
const _hoisted_97 = {
  key: 1,
  class: "space-y-3"
};
const _hoisted_98 = {
  class: "flex items-center justify-between"
};
const _hoisted_99 = {
  class: "flex items-center gap-2"
};
const _hoisted_100 = {
  class: "rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700"
};
const _hoisted_101 = {
  key: 0,
  class: "flex items-center gap-1 rounded-full status-badge is-success px-2 py-0.5 text-[10px] font-medium"
};
const _hoisted_102 = ["onClick"];
const _hoisted_103 = {
  class: "mt-3 text-sm font-medium text-slate-900"
};
const _hoisted_104 = {
  key: 0,
  class: "mt-1.5 text-xs text-slate-500 line-clamp-2"
};
const _hoisted_105 = {
  class: "mt-3 flex items-center gap-3 text-xs text-slate-400"
};
const _hoisted_106 = {
  class: "flex items-center gap-1"
};
const _hoisted_107 = {
  class: "flex items-center gap-1"
};
const _hoisted_108 = {
  key: 0,
  class: "flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-200 py-12"
};
const _hoisted_109 = {
  class: "flex flex-col items-center px-6 pt-8 pb-4"
};
const _hoisted_110 = {
  class: "mt-2 text-center text-sm text-slate-600 leading-relaxed"
};
const _hoisted_111 = {
  class: "flex gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
import { onMounted, onUnmounted, reactive, ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import KbCategoryTree from './components/KbCategoryTree.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import { useKbCategoryManagement } from './composables/useKbCategoryManagement';
import { formatDateTimeText } from '@/utils/dateFormat';
import AppModal from '@/components/AppModal.vue';
import KbDetailPreviewModal from '@/components/KbDetailPreviewModal.vue';
import { getFaqCategoryTree, createFaqCategory, updateFaqCategory, deleteFaqCategory, getFaqItemPage, getFaqItemDetail, createFaqItem, updateFaqItem, deleteFaqItem, publishFaqItem, archiveFaqItem, toggleFaqItemTop, getFaqVersions, rollbackFaqItem } from '@/api/kb';

// ==================== 分类相关 ====================

export default {
  __name: 'FaqManagement',
  setup(__props) {
    const categoryState = useKbCategoryManagement({
      loadCategoryTree: getFaqCategoryTree,
      createCategory: createFaqCategory,
      updateCategory: updateFaqCategory,
      defaultStatus: 1,
      includeRemark: true,
      messages: {
        loadError: '\u52a0\u8f7d\u5206\u7c7b\u5931\u8d25',
        emptyNameWarning: '\u8bf7\u8f93\u5165\u5206\u7c7b\u540d\u79f0',
        updateSuccess: '\u5206\u7c7b\u66f4\u65b0\u6210\u529f',
        createSuccess: '\u5206\u7c7b\u521b\u5efa\u6210\u529f',
        saveError: '\u4fdd\u5b58\u5206\u7c7b\u5931\u8d25'
      }
    });
    const categoryTree = categoryState.categoryTree;
    const categoryLoading = categoryState.categoryLoading;
    const selectedCategoryId = categoryState.selectedCategoryId;
    const showCategoryModal = categoryState.showCategoryModal;
    const isCategoryEdit = categoryState.isCategoryEdit;
    const categoryForm = categoryState.categoryForm;
    const loadCategories = categoryState.loadCategories;
    const flatCategories = categoryState.flatCategories;
    const getCategoryName = categoryState.getCategoryName;
    const getLastCategoryName = categoryState.getLastCategoryName;
    const handleCategorySelect = categoryState.handleCategorySelect;
    const handleAddCategory = categoryState.handleAddCategory;
    const handleAddChildCategory = categoryState.handleAddChildCategory;
    const handleEditCategory = categoryState.handleEditCategory;
    const closeCategoryModal = categoryState.closeCategoryModal;
    const submitCategory = categoryState.submitCategory;
    const faqList = ref([]);
    const listLoading = ref(false);
    const searchKeyword = ref('');
    const searchStatus = ref('');
    const pageSize = ref(20);
    const pageInfo = reactive({
      current: 1,
      total: 0,
      hasPrevious: false,
      hasNext: false
    });
    const loadFaqList = async (page = 1) => {
      listLoading.value = true;
      try {
        const params = {
          page,
          size: pageSize.value,
          categoryId: selectedCategoryId.value || undefined,
          keyword: searchKeyword.value || undefined,
          status: searchStatus.value === '' ? undefined : Number(searchStatus.value)
        };
        const data = await getFaqItemPage(params);
        faqList.value = data.records || [];
        Object.assign(pageInfo, {
          current: data.current || 1,
          total: data.total || 0,
          hasPrevious: data.hasPrevious,
          hasNext: data.hasNext
        });
      } catch (error) {
        ElMessage.error(error.message || '加载FAQ列表失败');
      } finally {
        listLoading.value = false;
      }
    };
    const resetFilters = () => {
      searchKeyword.value = '';
      searchStatus.value = '';
      selectedCategoryId.value = null;
      loadFaqList(1);
    };
    const handleCategoryTreeSelect = id => {
      handleCategorySelect(id, () => loadFaqList(1));
    };
    const handlePageChange = page => {
      loadFaqList(page);
    };
    const handlePageSizeChange = size => {
      pageSize.value = size;
      loadFaqList(1);
    };
    const statusText = status => ({
      0: '草稿',
      1: '已发布',
      2: '已归档'
    })[status] || '未知';
    const statusClass = status => ({
      0: 'status-badge is-neutral',
      1: 'status-badge is-success',
      2: 'status-badge is-warning'
    })[status] || 'status-badge is-neutral';

    // ==================== FAQ表单弹窗 ====================
    const showFormModal = ref(false);
    const isEdit = ref(false);
    const faqForm = reactive({
      id: null,
      categoryId: '',
      title: '',
      content: '',
      tags: '',
      status: 0,
      isTop: 0,
      remark: ''
    });
    const openFormModal = async item => {
      if (item) {
        isEdit.value = true;
        try {
          const data = await getFaqItemDetail(item.id);
          Object.assign(faqForm, {
            id: data.id,
            categoryId: data.categoryId,
            title: data.title,
            content: data.content || '',
            tags: data.tags || '',
            status: data.status,
            isTop: data.isTop || 0,
            remark: data.remark || ''
          });
        } catch (error) {
          ElMessage.error(error.message || '加载FAQ详情失败');
          return;
        }
      } else {
        isEdit.value = false;
        Object.assign(faqForm, {
          id: null,
          categoryId: selectedCategoryId.value || '',
          title: '',
          content: '',
          tags: '',
          status: 0,
          isTop: 0,
          remark: ''
        });
      }
      showFormModal.value = true;
    };
    const closeFormModal = () => {
      showFormModal.value = false;
    };
    const submitFaq = async () => {
      if (!faqForm.categoryId) {
        ElMessage.warning('请选择分类');
        return;
      }
      if (!faqForm.title.trim()) {
        ElMessage.warning('请输入标题');
        return;
      }
      if (!faqForm.content || faqForm.content === '<p></p>') {
        ElMessage.warning('请输入内容');
        return;
      }
      try {
        if (isEdit.value) {
          await updateFaqItem(faqForm.id, {
            categoryId: faqForm.categoryId,
            title: faqForm.title,
            content: faqForm.content,
            tags: faqForm.tags,
            status: faqForm.status,
            isTop: faqForm.isTop,
            remark: faqForm.remark
          });
          ElMessage.success('FAQ更新成功');
        } else {
          await createFaqItem({
            categoryId: faqForm.categoryId,
            title: faqForm.title,
            content: faqForm.content,
            tags: faqForm.tags,
            status: faqForm.status,
            isTop: faqForm.isTop,
            remark: faqForm.remark
          });
          ElMessage.success('FAQ创建成功');
        }
        closeFormModal();
        await loadFaqList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '保存FAQ失败');
      }
    };

    // ==================== FAQ详情弹窗 ====================
    const showDetailModal = ref(false);
    const detailData = ref(null);
    const detailLoading = ref(false);
    const openDetailModal = async item => {
      showDetailModal.value = true;
      detailLoading.value = true;
      try {
        detailData.value = await getFaqItemDetail(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载详情失败');
      } finally {
        detailLoading.value = false;
      }
    };

    // ==================== 小程序预览 ====================
    const showMpPreviewModal = ref(false);
    const previewItemId = ref(null);
    const previewFaqData = ref(null);

    // 列表入口：预览已保存FAQ（走详情接口）
    const openMpPreview = id => {
      previewFaqData.value = null;
      previewItemId.value = id;
      showMpPreviewModal.value = true;
    };

    // 表单入口：预览当前编辑内容（含未保存修改），数据形状与预览组件约定一致
    const openFormMpPreview = () => {
      previewItemId.value = null;
      previewFaqData.value = {
        title: faqForm.title,
        content: faqForm.content,
        tags: faqForm.tags,
        isTop: faqForm.isTop,
        status: faqForm.status
      };
      showMpPreviewModal.value = true;
    };

    // ==================== 操作 ====================
    const handlePublish = async item => {
      openMoreId.value = null;
      try {
        await publishFaqItem(item.id);
        ElMessage.success('发布成功');
        await loadFaqList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '发布失败');
      }
    };
    const handleArchive = async item => {
      openMoreId.value = null;
      try {
        await archiveFaqItem(item.id);
        ElMessage.success('归档成功');
        await loadFaqList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '归档失败');
      }
    };
    const handleToggleTop = async item => {
      openMoreId.value = null;
      try {
        await toggleFaqItemTop(item.id);
        ElMessage.success(item.isTop ? '已取消置顶' : '已置顶');
        await loadFaqList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };

    // ==================== 更多菜单 ====================
    const openMoreId = ref(null);
    const openMoreItem = ref(null);
    const moreMenuPos = reactive({
      top: 0,
      left: 0
    });
    const moreBtnRefs = {};
    const moreMenuStyle = computed(() => ({
      top: `${moreMenuPos.top}px`,
      left: `${moreMenuPos.left}px`
    }));
    const setMoreBtnRef = (id, el) => {
      if (el) moreBtnRefs[id] = el;
    };
    const toggleMoreMenu = (id, event) => {
      if (openMoreId.value === id) {
        openMoreId.value = null;
        openMoreItem.value = null;
      } else {
        const item = faqList.value.find(f => f.id === id);
        openMoreItem.value = item;
        openMoreId.value = id;
        // 计算菜单位置
        const btn = event.currentTarget;
        const rect = btn.getBoundingClientRect();
        moreMenuPos.top = rect.bottom + 4;
        moreMenuPos.left = rect.right - 144; // 144 = w-36 (9rem)
      }
    };
    const handleClickOutside = e => {
      if (openMoreId.value && !e.target.closest('.more-menu-container')) {
        openMoreId.value = null;
        openMoreItem.value = null;
      }
    };

    // ==================== 版本历史 ====================
    const showVersionDrawer = ref(false);
    const versionList = ref([]);
    const versionLoading = ref(false);
    const versionFaqItem = ref(null);
    const openVersionDrawer = async item => {
      versionFaqItem.value = item;
      showVersionDrawer.value = true;
      versionLoading.value = true;
      try {
        versionList.value = await getFaqVersions(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载版本失败');
      } finally {
        versionLoading.value = false;
      }
    };
    const handleRollback = async version => {
      try {
        await rollbackFaqItem(versionFaqItem.value.id, version.versionNumber);
        ElMessage.success('回滚成功');
        showVersionDrawer.value = false;
        await loadFaqList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '回滚失败');
      }
    };

    // ==================== 删除确认 ====================
    const showConfirmModal = ref(false);
    const confirmMessage = ref('');
    const confirmPayload = ref({
      type: '',
      id: null
    });
    const confirmDeleteCategory = node => {
      confirmPayload.value = {
        type: 'category',
        id: node.id
      };
      confirmMessage.value = `确认删除分类「${node.name}」？分类下的子分类和FAQ将无法访问。`;
      showConfirmModal.value = true;
    };
    const confirmDeleteFaq = item => {
      openMoreId.value = null;
      confirmPayload.value = {
        type: 'faq',
        id: item.id
      };
      confirmMessage.value = `确认删除FAQ「${item.title}」？`;
      showConfirmModal.value = true;
    };
    const confirmDeleteAction = async () => {
      const {
        type,
        id
      } = confirmPayload.value;
      try {
        if (type === 'category') {
          await deleteFaqCategory(id);
          ElMessage.success('分类已删除');
          await loadCategories();
        } else {
          await deleteFaqItem(id);
          ElMessage.success('FAQ已删除');
          await loadFaqList(pageInfo.current);
        }
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        showConfirmModal.value = false;
      }
    };

    // ==================== 初始化 ====================
    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await loadCategories();
      await loadFaqList(1);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      const _directive_safe_html = _resolveDirective("safe-html");
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "常见问题"), _createElementVNode("p", {
          class: "list-page-description"
        }, "面向全部用户的问答知识库，支持分类、版本与评价管理。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(KbCategoryTree, {
          tree: _unref(categoryTree),
          loading: _unref(categoryLoading),
          "selected-id": _unref(selectedCategoryId),
          title: "FAQ分类",
          description: "支持多级分类，拖拽排序。",
          onAdd: _unref(handleAddCategory),
          onAddChild: _unref(handleAddChildCategory),
          onEdit: _unref(handleEditCategory),
          onDelete: confirmDeleteCategory,
          onSelect: handleCategoryTreeSelect
        }, null, 8, ["tree", "loading", "selected-id", "onAdd", "onAddChild", "onEdit"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": listLoading.value,
          onRefresh: _cache[5] || (_cache[5] = $event => loadFaqList(pageInfo.current))
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[3] || (_cache[3] = $event => openFormModal()),
            class: "btn-primary"
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增FAQ ", -1)]))])), [[_directive_permission, 'kb:faq:edit']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = $event => loadFaqList(1)),
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            onClick: resetFilters,
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索问题或关键词",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _cache[1] || (_cache[1] = _withKeys($event => loadFaqList(1), ["enter"]))
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[34] || (_cache[34] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchStatus.value = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "草稿",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "已发布",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "已归档",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("table", _hoisted_8, [_cache[45] || (_cache[45] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "问题"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "标签"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "分类"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "状态"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "置顶"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "浏览"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "评价"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "版本"), _createElementVNode("th", {
          class: "px-5 py-3 text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [listLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "data-table-row"
          }, [...(_cache[36] || (_cache[36] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-48"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-20"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-16"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-14 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-8"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-10"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-16"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-8"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "mx-auto flex justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          })])], -1)]))]);
        }), 64)) : !faqList.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[37] || (_cache[37] = [_createElementVNode("td", {
          colspan: "9",
          class: "px-5 py-8 text-center text-sm text-slate-500"
        }, "暂无FAQ数据", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row group/row"
          }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "flex-shrink-0 mt-0.5"
          }, [_createElementVNode("div", {
            class: "flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-br from-primary-50 to-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })])])], -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
            class: "data-table-cell-title cursor-default line-clamp-2 group-hover/row:text-primary-600 transition-colors",
            title: item.title
          }, _toDisplayString(item.title), 9, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(item.createTime?.slice(0, 10) || '-'), 1), item.createByName ? (_openBlock(), _createElementBlock("span", _hoisted_15, "· " + _toDisplayString(item.createByName), 1)) : _createCommentVNode("", true)])])])]), _createElementVNode("td", _hoisted_16, [item.tags ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags.split(','), tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: "data-table-inline-tag"
            }, _toDisplayString(tag.trim()), 1);
          }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))]), _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(getLastCategoryName)(item.categoryId)), 1), _createElementVNode("td", _hoisted_20, [_createElementVNode("span", {
            class: _normalizeClass(statusClass(item.status))
          }, _toDisplayString(statusText(item.status)), 3)]), _createElementVNode("td", _hoisted_21, [item.isTop ? (_openBlock(), _createElementBlock("span", _hoisted_22, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
            class: "mx-auto h-4 w-4",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [_createElementVNode("path", {
            d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          })], -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))]), _createElementVNode("td", _hoisted_24, _toDisplayString(item.viewCount || 0), 1), _createElementVNode("td", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(item.likeCount || 0), 1), _cache[40] || (_cache[40] = _createElementVNode("span", {
            class: "text-slate-300"
          }, "/", -1)), _createElementVNode("span", _hoisted_28, _toDisplayString(item.dislikeCount || 0), 1)])]), _createElementVNode("td", _hoisted_29, [_createElementVNode("button", {
            onClick: $event => openVersionDrawer(item),
            class: "text-xs text-primary-600 hover:text-primary-700 hover:underline"
          }, "v" + _toDisplayString(item.currentVersion || 1), 9, _hoisted_30)]), _createElementVNode("td", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("button", {
            onClick: $event => openDetailModal(item),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_33), _createElementVNode("button", {
            onClick: $event => openMpPreview(item.id),
            class: "table-action-button is-teal",
            title: "小程序预览",
            "aria-label": "小程序预览"
          }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })], -1)]))], 8, _hoisted_34), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openFormModal(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[43] || (_cache[43] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_35)), [[_directive_permission, 'kb:faq:edit']]), _createElementVNode("div", _hoisted_36, [_withDirectives((_openBlock(), _createElementBlock("button", {
            ref_for: true,
            ref: el => setMoreBtnRef(item.id, el),
            onClick: _withModifiers($event => toggleMoreMenu(item.id, $event), ["stop"]),
            class: "table-action-button is-neutral",
            title: "更多操作"
          }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
          })], -1)]))], 8, _hoisted_37)), [[_directive_permission, 'kb:faq:edit']])])])])]);
        }), 128))])])])]), pageInfo.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pageInfo,
          size: pageSize.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "size"])) : _createCommentVNode("", true)])])]), _createVNode(_Transition, {
          name: "modal",
          onAfterLeave: _ctx.onModalLeave
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: _unref(showCategoryModal),
            size: "md",
            "panel-class": "ring-1 ring-black/5 duration-300 ease-out",
            onClose: _unref(closeCategoryModal)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_cache[47] || (_cache[47] = _createElementVNode("div", {
              class: "absolute inset-0 bg-grid-white/10"
            }, null, -1)), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_40, _toDisplayString(_unref(isCategoryEdit) ? '编辑分类' : '新增分类'), 1), _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(isCategoryEdit) ? '修改分类信息' : '创建新的FAQ分类'), 1)]), _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = (...args) => _unref(closeCategoryModal) && _unref(closeCategoryModal)(...args)),
              class: "cursor-pointer rounded-full p-1.5 text-white/80 transition-all hover:bg-white/20 hover:text-white"
            }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_cache[48] || (_cache[48] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            })]), _createTextVNode(" 分类名称 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(categoryForm).name = $event),
              class: "form-input",
              placeholder: "请输入分类名称"
            }, null, 512), [[_vModelText, _unref(categoryForm).name]])]), _createElementVNode("div", _hoisted_44, [_cache[49] || (_cache[49] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            })]), _createTextVNode(" 上级分类 ")], -1)), _createVNode(_component_el_select, {
              modelValue: _unref(categoryForm).parentId,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(categoryForm).parentId = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "顶级分类",
                value: 0
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatCategories), cat => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: cat.id,
                  label: cat.label,
                  value: cat.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]), _cache[55] || (_cache[55] = _createElementVNode("div", {
              class: "mx-6 border-t border-dashed border-slate-200"
            }, null, -1)), _createElementVNode("div", _hoisted_45, [_cache[54] || (_cache[54] = _createElementVNode("p", {
              class: "text-xs font-medium text-slate-400 uppercase tracking-wider"
            }, "可选信息", -1)), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[50] || (_cache[50] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
            })]), _createTextVNode(" 排序号 ")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(categoryForm).sort = $event),
              type: "number",
              class: "form-input",
              placeholder: "0"
            }, null, 512), [[_vModelText, _unref(categoryForm).sort, void 0, {
              number: true
            }]])]), _createElementVNode("div", _hoisted_48, [_cache[51] || (_cache[51] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            })]), _createTextVNode(" 状态 ")], -1)), _createVNode(_component_el_select, {
              modelValue: _unref(categoryForm).status,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(categoryForm).status = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "启用",
                value: 0
              }), _createVNode(_component_el_option, {
                label: "停用",
                value: 1
              })]),
              _: 1
            }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_49, [_cache[52] || (_cache[52] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
            })]), _createTextVNode(" 备注 ")], -1)), _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(categoryForm).remark = $event),
              rows: "2",
              class: "form-textarea",
              placeholder: "可选备注信息"
            }, null, 512), [[_vModelText, _unref(categoryForm).remark]]), _cache[53] || (_cache[53] = _createElementVNode("p", {
              class: "form-helper"
            }, "填写备注有助于分类管理", -1))])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = (...args) => _unref(closeCategoryModal) && _unref(closeCategoryModal)(...args)),
              class: "btn-secondary"
            }, "取消"), _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = (...args) => _unref(submitCategory) && _unref(submitCategory)(...args)),
              class: "btn-primary hover:shadow-md hover:shadow-primary-500/30"
            }, _toDisplayString(_unref(isCategoryEdit) ? '保存修改' : '创建分类'), 1)])]),
            _: 1
          }, 8, ["visible", "onClose"])]),
          _: 1
        }, 8, ["onAfterLeave"]), _createVNode(AppModal, {
          visible: showFormModal.value,
          size: "3xl",
          "panel-class": "ring-1 ring-black/5",
          onClose: closeFormModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_cache[57] || (_cache[57] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_53, _toDisplayString(isEdit.value ? '编辑FAQ' : '新增FAQ'), 1), _createElementVNode("p", _hoisted_54, _toDisplayString(isEdit.value ? '编辑将自动产生新版本记录' : '创建新的常见问题'), 1)]), _createElementVNode("button", {
            onClick: closeFormModal,
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[56] || (_cache[56] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_cache[60] || (_cache[60] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })])]), _createTextVNode(" 基本信息 ")], -1)), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_cache[58] || (_cache[58] = _createElementVNode("label", {
            class: "flex items-center gap-1 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          })]), _createTextVNode(" 所属分类 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: faqForm.categoryId,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => faqForm.categoryId = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "请选择分类",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatCategories), cat => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: cat.id,
                label: cat.label,
                value: cat.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_59, [_cache[59] || (_cache[59] = _createElementVNode("label", {
            class: "flex items-center gap-1 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 标题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => faqForm.title = $event),
            class: "form-input",
            placeholder: "请输入FAQ标题"
          }, null, 512), [[_vModelText, faqForm.title]])])])]), _createElementVNode("div", _hoisted_60, [_cache[61] || (_cache[61] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h7"
          })])]), _createTextVNode(" 内容 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(RichTextEditor, {
            modelValue: faqForm.content,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => faqForm.content = $event),
            "upload-module": "faq"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_61, [_cache[66] || (_cache[66] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
          })])]), _createTextVNode(" 标签与设置 ")], -1)), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_cache[62] || (_cache[62] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "标签", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => faqForm.tags = $event),
            class: "form-input",
            placeholder: "多个标签用逗号分隔，如：加盟,费用,政策"
          }, null, 512), [[_vModelText, faqForm.tags]])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_cache[63] || (_cache[63] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "状态", -1)), _createVNode(_component_el_select, {
            modelValue: faqForm.status,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => faqForm.status = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "草稿",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "已发布",
              value: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_66, [_cache[64] || (_cache[64] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "置顶", -1)), _createVNode(_component_el_select, {
            modelValue: faqForm.isTop,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => faqForm.isTop = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "否",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "是",
              value: 1
            })]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_67, [_cache[65] || (_cache[65] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => faqForm.remark = $event),
            rows: "2",
            class: "form-textarea",
            placeholder: "可选备注信息"
          }, null, 512), [[_vModelText, faqForm.remark]])])])])]), _createElementVNode("div", {
            class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
          }, [_createElementVNode("button", {
            onClick: openFormMpPreview,
            class: "rounded-lg border border-primary-200 px-4 py-2 text-sm text-primary-700 hover:bg-primary-50"
          }, "预览小程序效果"), _createElementVNode("button", {
            onClick: closeFormModal,
            class: "cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: submitFaq,
            class: "cursor-pointer rounded-lg bg-primary-700 px-5 py-2 text-sm font-medium text-white shadow-sm shadow-primary-600/30 transition-all hover:bg-primary-800 hover:shadow-md hover:shadow-primary-600/40"
          }, "保存")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "3xl",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[22] || (_cache[22] = $event => showDetailModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_68, [_cache[69] || (_cache[69] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_69, [_cache[68] || (_cache[68] = _createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-white"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-white"
          }, "FAQ详情"), _createElementVNode("p", {
            class: "mt-0.5 text-sm text-primary-100"
          }, "查看问答详细内容")])], -1)), _createElementVNode("button", {
            onClick: _cache[21] || (_cache[21] = $event => showDetailModal.value = false),
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[67] || (_cache[67] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_70, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_71, [...(_cache[70] || (_cache[70] = [_createElementVNode("div", {
            class: "h-8 w-3/4 rounded-lg bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "h-5 w-1/2 rounded bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "h-40 rounded-xl bg-slate-200"
          }, null, -1)]))])) : detailData.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_72, [_createElementVNode("span", {
            class: _normalizeClass(statusClass(detailData.value.status))
          }, _toDisplayString(statusText(detailData.value.status)), 3), detailData.value.isTop ? (_openBlock(), _createElementBlock("span", _hoisted_73, [...(_cache[71] || (_cache[71] = [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [_createElementVNode("path", {
            d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          })], -1), _createTextVNode(" 置顶 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_74, [_cache[72] || (_cache[72] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
          })], -1)), _createTextVNode(" v" + _toDisplayString(detailData.value.currentVersion), 1)])]), _createElementVNode("h2", _hoisted_75, _toDisplayString(detailData.value.title), 1), detailData.value.tags ? (_openBlock(), _createElementBlock("div", _hoisted_76, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((detailData.value.tags || '').split(',').filter(Boolean), tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: "rounded-full status-badge is-neutral px-2.5 py-1 text-xs"
            }, _toDisplayString(tag.trim()), 1);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_cache[73] || (_cache[73] = _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)), _createTextVNode(" 浏览 " + _toDisplayString(detailData.value.viewCount || 0) + " 次 ", 1)]), _createElementVNode("div", _hoisted_79, [_cache[74] || (_cache[74] = _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
          })], -1)), _createTextVNode(" 有用 " + _toDisplayString(detailData.value.likeCount || 0), 1)]), _createElementVNode("div", _hoisted_80, [_cache[75] || (_cache[75] = _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
          })], -1)), _createTextVNode(" 无用 " + _toDisplayString(detailData.value.dislikeCount || 0), 1)]), _createElementVNode("div", _hoisted_81, [_cache[76] || (_cache[76] = _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          })], -1)), _createTextVNode(" " + _toDisplayString(detailData.value.categoryName || _unref(getCategoryName)(detailData.value.categoryId)), 1)])]), _createElementVNode("div", _hoisted_82, [_cache[77] || (_cache[77] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900 mb-3"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h7"
          })])]), _createTextVNode(" 答案内容 ")], -1)), _createElementVNode("div", _hoisted_83, [_withDirectives(_createElementVNode("div", _hoisted_84, null, 512), [[_directive_safe_html, detailData.value.content]])])]), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_cache[78] || (_cache[78] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _createTextVNode(" 创建：" + _toDisplayString(detailData.value.createTime || '-'), 1)]), _createElementVNode("div", _hoisted_87, [_cache[79] || (_cache[79] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" 更新：" + _toDisplayString(detailData.value.updateTime || '-'), 1)])])], 64)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"]), showVersionDrawer.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_88, [_createElementVNode("div", {
          class: "absolute inset-0 bg-black/60 backdrop-blur-sm",
          onClick: _cache[23] || (_cache[23] = $event => showVersionDrawer.value = false)
        }), _createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_cache[82] || (_cache[82] = _createElementVNode("div", {
          class: "absolute inset-0 bg-grid-white/10"
        }, null, -1)), _createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [_cache[80] || (_cache[80] = _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "h-5 w-5 text-white/80",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })]), _createElementVNode("h3", {
          class: "text-lg font-semibold text-white"
        }, "版本历史")], -1)), _createElementVNode("p", _hoisted_94, _toDisplayString(versionFaqItem.value?.title), 1)]), _createElementVNode("button", {
          onClick: _cache[24] || (_cache[24] = $event => showVersionDrawer.value = false),
          class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
        }, [...(_cache[81] || (_cache[81] = [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])])]), _createElementVNode("div", _hoisted_95, [versionLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_96, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
          return _createElementVNode("div", {
            key: n,
            class: "rounded-xl border border-slate-200 p-4"
          }, [...(_cache[83] || (_cache[83] = [_createElementVNode("div", {
            class: "h-5 w-16 rounded-full bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "mt-3 h-4 w-40 rounded bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "mt-2 h-3 w-24 rounded bg-slate-200"
          }, null, -1)]))]);
        }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_97, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versionList.value, version => {
          return _openBlock(), _createElementBlock("div", {
            key: version.id,
            class: "group cursor-pointer rounded-xl border border-slate-200 bg-white p-4 transition-all hover:border-primary-200 hover:shadow-md"
          }, [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createElementVNode("span", _hoisted_100, "v" + _toDisplayString(version.versionNumber), 1), version.versionNumber === versionFaqItem.value?.currentVersion ? (_openBlock(), _createElementBlock("span", _hoisted_101, [...(_cache[84] || (_cache[84] = [_createElementVNode("svg", {
            class: "h-3 w-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1), _createTextVNode(" 当前版本 ", -1)]))])) : _createCommentVNode("", true)]), version.versionNumber !== versionFaqItem.value?.currentVersion ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleRollback(version),
            class: "cursor-pointer rounded-lg px-2.5 py-1 text-xs font-medium text-primary-600 opacity-0 transition-all hover:bg-primary-50 group-hover:opacity-100"
          }, [...(_cache[85] || (_cache[85] = [_createTextVNode("回滚", -1)]))], 8, _hoisted_102)), [[_directive_permission, 'kb:faq:edit']]) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_103, _toDisplayString(version.title), 1), version.changeSummary ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(version.changeSummary), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_105, [_createElementVNode("span", _hoisted_106, [_cache[86] || (_cache[86] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _createTextVNode(" " + _toDisplayString(_unref(formatDateTimeText)(version.createTime)), 1)]), _createElementVNode("span", _hoisted_107, [_cache[87] || (_cache[87] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)), _createTextVNode(" " + _toDisplayString(version.createByName || '系统'), 1)])])]);
        }), 128)), !versionList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_108, [...(_cache[88] || (_cache[88] = [_createElementVNode("div", {
          class: "flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400"
        }, [_createElementVNode("svg", {
          class: "h-6 w-6",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })])], -1), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无版本记录", -1)]))])) : _createCommentVNode("", true)]))])])])])), [[_directive_modal_a11y, () => showVersionDrawer.value = false]]) : _createCommentVNode("", true), _createVNode(AppModal, {
          visible: showConfirmModal.value,
          size: "sm",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[26] || (_cache[26] = $event => showConfirmModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_109, [_cache[89] || (_cache[89] = _createElementVNode("div", {
            class: "flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600"
          }, [_createElementVNode("svg", {
            class: "h-7 w-7",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[90] || (_cache[90] = _createElementVNode("h3", {
            class: "mt-4 text-lg font-semibold text-slate-900"
          }, "确认删除", -1)), _createElementVNode("p", _hoisted_110, _toDisplayString(confirmMessage.value), 1)]), _createElementVNode("div", _hoisted_111, [_createElementVNode("button", {
            onClick: _cache[25] || (_cache[25] = $event => showConfirmModal.value = false),
            class: "flex-1 cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteAction,
            class: "flex-1 cursor-pointer rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm shadow-red-600/30 transition-all hover:bg-red-700 hover:shadow-md hover:shadow-red-600/40"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [openMoreId.value !== null ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed z-[9999] w-40 overflow-hidden rounded-xl border border-slate-200 bg-white py-1.5 shadow-xl ring-1 ring-black/5",
          style: _normalizeStyle(moreMenuStyle.value),
          onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
        }, [openMoreItem.value?.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[27] || (_cache[27] = $event => handlePublish(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [...(_cache[91] || (_cache[91] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-emerald-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createTextVNode(" 发布 ", -1)]))])), [[_directive_permission, 'kb:faq:edit']]) : _createCommentVNode("", true), openMoreItem.value?.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[28] || (_cache[28] = $event => handleArchive(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [...(_cache[92] || (_cache[92] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-amber-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
        })], -1), _createTextVNode(" 归档 ", -1)]))])), [[_directive_permission, 'kb:faq:edit']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[29] || (_cache[29] = $event => handleToggleTop(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-slate-700 transition-colors hover:bg-slate-50"
        }, [_cache[93] || (_cache[93] = _createElementVNode("svg", {
          class: "h-4 w-4 text-amber-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 15l7-7 7 7"
        })], -1)), _createTextVNode(" " + _toDisplayString(openMoreItem.value?.isTop ? '取消置顶' : '置顶'), 1)])), [[_directive_permission, 'kb:faq:edit']]), _cache[95] || (_cache[95] = _createElementVNode("div", {
          class: "my-1 border-t border-slate-100"
        }, null, -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[30] || (_cache[30] = $event => confirmDeleteFaq(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-xs text-red-600 transition-colors hover:bg-red-50"
        }, [...(_cache[94] || (_cache[94] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1), _createTextVNode(" 删除 ", -1)]))])), [[_directive_permission, 'kb:faq:edit']])], 4)) : _createCommentVNode("", true)])), _createVNode(KbDetailPreviewModal, {
          modelValue: showMpPreviewModal.value,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => showMpPreviewModal.value = $event),
          type: "faq",
          "item-id": previewItemId.value,
          "preview-data": previewFaqData.value
        }, null, 8, ["modelValue", "item-id", "preview-data"])]),
        _: 1
      });
    };
  }
};